/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_NameInputs */

const en_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media Name`)
};

const fr_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du média`)
};

const de_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medienname`)
};

const it_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del supporto`)
};

const ru_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название медиафайла`)
};

const es_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del medio`)
};

const zh_cn2_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体名称`)
};

const ja_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディア名`)
};

const hi_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया का नाम`)
};

const pt_pt2_media_name = /** @type {(inputs: Media_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da mídia`)
};

/**
* | output |
* | --- |
* | "Media Name" |
*
* @param {Media_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_name = /** @type {((inputs?: Media_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_name(inputs)
	if (locale === "de") return de_media_name(inputs)
	if (locale === "it") return it_media_name(inputs)
	if (locale === "ru") return ru_media_name(inputs)
	if (locale === "es") return es_media_name(inputs)
	if (locale === "zh-CN") return zh_cn2_media_name(inputs)
	if (locale === "ja") return ja_media_name(inputs)
	if (locale === "hi") return hi_media_name(inputs)
	if (locale === "pt-PT") return pt_pt2_media_name(inputs)
	return en_media_name(inputs)
});